import * as FORMS from '@widergy/utilitygo-forms-web/dist/constants/fieldTypes';

import { message } from 'utils/stringUtils';

export const nameField = {
  id: 3,
  type: FORMS.FIELD_TEXT,
  key: 'username',
  required: true,
  title: message('EntitiesComplaint:username')
};
